module.exports = __webpack_public_path__ + "static/FAQ-jobs2-4b829f0bc6c2cba872bb7c4407819aa7.jpg";